import { Box } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { productCarouselSchema } from "../../../src/constants/carouselSchema";

import { faqP1Schema } from "../../../src/constants/structuredFAQ";
import { cityArray, cityOptionsForQuotation } from "../../../src/constants";
import { Context } from "../../../src/context/context";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import { MemoizedOldVehicles } from "../../../src/modules/Vehicles/oldVehicles";
import { MemoizedStatePopup } from "../../../src/Popups/statePopup/StatePopup";
import TopBanner from "../../../src/SDK/Banner/topBanner";

export default function Vehicles({ city }) {
  const { changeCity } = useContext(Context);
  const state = useContext(Context);

  const navigate = useRouter();

  const cityName = city?.charAt(0)?.toUpperCase() + city?.slice(1);

  useEffect(() => {
    const cityName = window.location.pathname.split("/")[1];
    if (cityName !== "all") {
      const selectedCity = cityName[0].toUpperCase() + cityName.slice(1);
      changeCity(selectedCity);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Head>
        <title>Electric Auto Price in {cityName} 2026 | Images, Range, Specs | Turno</title>
        <meta
          name="description"
          content={`Explore the electric auto price in ${cityName} and discover top EV autos, electric 3-wheelers, and e-rickshaw prices. Compare models, battery range, and commercial auto prices in ${cityName} to find your best deal.`}
        />
        <meta
          name="keywords"
          content={`Electric Auto Rickshaw in ${cityName}, electric auto price ${cityName}, electric 3 wheeler ${cityName}, EV auto ${cityName}, electric commercial vehicle ${cityName}, Turno, electric three wheeler, electric commercial vehicle price, 3 wheeler loading auto, electric goods vehicle, 3 wheeler, mahindra ev, piaggio price, etrio, osm`}
        />
        <meta name="author" content="Turno" />
        <meta
          name="url"
          content={`https://www.turno.club/${city}/electric-auto`}
        />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta
          property="og:url"
          content={`https://www.turno.club/${city}/electric-auto`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`Electric Auto Price in ${cityName} 2026 | Images, Range, Specs | Turno`}
        />
        <meta
          property="og:description"
          content={`Explore the electric auto price in ${cityName} and discover top EV autos, electric 3-wheelers, and e-rickshaw prices. Compare models, battery range, and commercial auto prices in ${cityName} to find your best deal.`}
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content={`Explore the electric auto price in ${cityName} and discover top EV autos, electric 3-wheelers, and e-rickshaw prices. Compare models, battery range, and commercial auto prices in ${cityName} to find your best deal.`}
        />
        <meta
          name="twitter:title"
          content={`Electric Auto Price in ${cityName} 2026 | Images, Range, Specs | Turno`}
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta
          name="twitter:url"
          content={`https://www.turno.club/${city}/electric-auto`}
        />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link
          rel="canonical"
          href={`https://www.turno.club/${city}/electric-auto`}
        />
        {/* <script type="application/ld+json">
          {JSON.stringify(faqP1Schema)}
        </script> */}

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqP1Schema) }}
        />

        {/* <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productCarousels),
          }}
        /> */}

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productCarouselSchema),
          }}
        />
      </Head>

      <body>
        <MemoizedStatePopup />

        <MemoizedHeader />

        <Box sx={{ mb: { xs: 0, md: 2 }, mt: 0 }}>
          <TopBanner
            location={cityName}
            vehicleName={"Electric Auto Rickshaw in"}
          />
        </Box>

        <MemoizedOldVehicles />

        <MemoizedFooter />
      </body>
    </>
  );
}

export const getServerSideProps = (context) => {
  try {
    // Read from params (recommended for dynamic routes)
    const city = context.params?.city || context.query?.city;

    // Guard for undefined and string[] - return 404 if missing or not a string
    if (!city || typeof city !== "string" || Array.isArray(city)) {
      return {
        notFound: true,
      };
    }

    // Create a list of valid cities from both arrays (with defensive checks)
    const validCities = [
      ...(Array.isArray(cityArray) ? cityArray.map(c => c?.name?.toLowerCase()).filter(Boolean) : []),
      ...(Array.isArray(cityOptionsForQuotation) ? cityOptionsForQuotation.map(c => c?.toLowerCase()).filter(Boolean) : []),
      // Add common variations
      'bangalore', 'bengaluru', 'hyderabad', 'hydrabad', 'mumbai', 'pune', 
      'chennai', 'delhi', 'gurgaon', 'noida', 'ghaziabad', 'all','tamil-nadu','gujarat','karnataka','maharashtra','telangana'
    ];

    // Check if the city is valid (case-insensitive)
    const isValidCity = validCities.includes(city.toLowerCase());

    if (!isValidCity) {
      return {
        notFound: true,
      };
    }

    return {
      props: { city },
    };
  } catch (error) {
    // If any error occurs, return 404 instead of 500
    console.error('Error in getServerSideProps for [city]/electric-auto:', error);
    return {
      notFound: true,
    };
  }
};
